import { render } from "./PartnersSection.vue?vue&type=template&id=00f3c0d2"
import script from "./PartnersSection.vue?vue&type=script&lang=js"
export * from "./PartnersSection.vue?vue&type=script&lang=js"
script.render = render

export default script